export const messageGet = "/sys/template";//获取列表
export const messagePost = "/sys/template";//新建消息
export const messageSeach = (id) => {return "/sys/template/" + id};//查看详情
export const messageEdit = (id) => {return "/sys/template/" + id};//修改消息
export const messageDel = (id) => {return "/sys/template/" + id};//删除消息
export const messageDisTrue = (id) => {return "/sys/template/" + id + "/enable"};//启用消息
export const messageDisFalse = (id) => {return "/sys/template/" + id + "/disable"};//禁用消息
export const messageSceneGet = "/sys/scene";//消息模板场景
